function toAmount(value) {
  const amount = Number(value)
  return Number.isFinite(amount) ? amount : 0
}

function sumBy(items, key) {
  return Array.isArray(items)
    ? items.reduce((sum, item) => sum + toAmount(item && item[key]), 0)
    : 0
}

export const FINANCE_SUMMARY_LABELS = [
  '残金',
  '住宅費(家賃・ローン)',
  '電気料金',
  'ガス料金',
  '水道料金',
  '食費',
  '被服費',
  '自動車(月々支払い)',
  '電話料金',
  '情報通信メディア',
  '日用品',
  '医療(医薬品・健康診断)',
  '貯蓄',
  '生命保険',
  '外食',
  '習い事(大人・子ども)',
  '防災用品',
  '旅行・レジャー'
]

export function buildFinanceSummary(state) {
  const breakdown = (state && state.breakdown) || {}

  const mainFood1 = toAmount(breakdown.main_food1)
  const mainFood2 = toAmount(breakdown.main_food2)
  const mainFood3 = toAmount(breakdown.main_food3)
  const mainFood4 = toAmount(breakdown.main_food4)
  const sideFood1 = toAmount(breakdown.side_food1)
  const sideFood2 = toAmount(breakdown.side_food2)
  const sideFood3 = toAmount(breakdown.side_food3)
  const sideFood4 = toAmount(breakdown.side_food4)

  return {
    balance: toAmount(breakdown.balance),
    house: toAmount(breakdown.house),
    electricity: toAmount(breakdown.electricity),
    gas: toAmount(breakdown.gas),
    water: toAmount(breakdown.water),
    food: mainFood1 + mainFood2 + mainFood3 + mainFood4 +
      sideFood1 + sideFood2 + sideFood3 + sideFood4,
    main_food1: mainFood1,
    main_food2: mainFood2,
    main_food3: mainFood3,
    main_food4: mainFood4,
    side_food1: sideFood1,
    side_food2: sideFood2,
    side_food3: sideFood3,
    side_food4: sideFood4,
    fashion: sumBy(breakdown.fashion_men, 'order') +
      sumBy(breakdown.fashion_women, 'order') +
      sumBy(breakdown.fashion_kids, 'order') +
      sumBy(breakdown.fashion_baby, 'order'),
    car: toAmount(breakdown.car),
    smartphone: toAmount(breakdown.smartphone_adult) +
      toAmount(breakdown.smartphone_kids),
    media: toAmount(breakdown.media_newspaper) +
      toAmount(breakdown.media_tv_radio) +
      toAmount(breakdown.media_books) +
      toAmount(breakdown.media_web) +
      toAmount(breakdown.media_isp),
    daily_necessities: toAmount(breakdown.daily_necessities_dental) +
      toAmount(breakdown.daily_necessities_laundry) +
      toAmount(breakdown.daily_necessities_sanitary) +
      toAmount(breakdown.daily_necessities_bath) +
      toAmount(breakdown.daily_necessities_kitchen) +
      toAmount(breakdown.daily_necessities_etc),
    medical: toAmount(breakdown.medical_medicine_internal) +
      toAmount(breakdown.medical_medicine_analgesic) +
      toAmount(breakdown.medical_medicine_external) +
      toAmount(breakdown.medical_medicine_etc) +
      toAmount(breakdown.medical_medicine_supplement) +
      toAmount(breakdown.medical_medicine_children) +
      sumBy(breakdown.medical_physical, 'order'),
    saving: toAmount(breakdown.saving),
    life_insurance_you: toAmount(breakdown.life_insurance_you),
    life_insurance_spouse: toAmount(breakdown.life_insurance_spouse),
    eat_out: sumBy(breakdown.eat_out, 'order'),
    lesson: sumBy(breakdown.lesson_adult, 'order') +
      sumBy(breakdown.lesson_child, 'order'),
    emergency_kit: toAmount(breakdown.emergency_kit),
    trip: sumBy(breakdown.trip, 'order_adult') +
      sumBy(breakdown.trip, 'order_child')
  }
}

export function financeSummaryChartValues(summary) {
  const value = summary || {}

  return [
    toAmount(value.balance),
    toAmount(value.house),
    toAmount(value.electricity),
    toAmount(value.gas),
    toAmount(value.water),
    toAmount(value.food),
    toAmount(value.fashion),
    toAmount(value.car),
    toAmount(value.smartphone),
    toAmount(value.media),
    toAmount(value.daily_necessities),
    toAmount(value.medical),
    toAmount(value.saving),
    toAmount(value.life_insurance_you) + toAmount(value.life_insurance_spouse),
    toAmount(value.eat_out),
    toAmount(value.lesson),
    toAmount(value.emergency_kit),
    toAmount(value.trip)
  ]
}
